<template>
  <div class="LoginModal">
    <header class="LoginModal-header">
      <button class="LoginModal-header-button" @click="hideModal">
        {{ $t('utils.action.cancel') }}
      </button>
    </header>
    <main class="LoginModal-main">
      <h3 class="LoginModal-main-title">{{ title }}</h3>
      <img
        :class="{ 'display-loader': isLoading }"
        class="LoginModal-main-loader"
        src="@/assets/animations/loader.svg"
      />
      <slot />
    </main>
  </div>
</template>
<script>
'use strict'
export default {
  name: 'LoginModal',
  props: {
    title: { type: String, default: '' },
    isLoading: { type: Boolean, default: false }
  },
  methods: {
    hideModal() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
.LoginModal {
  display: flex;
  flex-direction: column;
  &-header {
    padding: 1rem;
    &-button {
      border: 1px solid $text-grey;
      color: $text-grey;
      padding: 0.5rem 2rem;
      border-radius: 5px;
      &:hover {
        background-color: $text-grey;
        color: $white;
      }
    }
  }
  &-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    min-height: 200px;
    margin-bottom: 1rem;
    margin-left: 1rem;
    margin-right: 1rem;
    &-title {
      color: $text-blue;
      margin-bottom: 2rem;
      display: flex;
      align-items: center;
      @media (max-width: $medium) {
        margin: 0 0.2rem 0.5rem 0.2rem;
        text-align: center;
      }
    }
    &-loader {
      width: 50px;
      height: 50px;
      display: none;
      &.display-loader {
        display: initial;
      }
    }
  }
}
</style>
